/* ============================================================================
   os-scroll-cta.js — scroll-to-section CTAs, done safely
   ----------------------------------------------------------------------------
   The landing page CTAs are MEANT to scroll to the product grid rather than
   navigate away. That intent is correct. The old implementation was not:

     <a href="javascript:;" onclick="...scrollIntoView...">

   href="javascript:;" means the anchor has no destination at all. If the
   handler does not run - a JS error earlier on the page, a blocked inline
   script, an in-app browser quirk - the button does nothing. On a site where
   51% of sessions are in the Instagram or Facebook webview and 6.37% of
   Clarity sessions throw a JS error, that is a bad bet.

   The pattern here keeps the scroll and removes the failure mode:

     <a href="#collection-tabs-section" data-os-scroll="#collection-tabs-section">

   - JS present  -> smooth scroll, page never changes. Same as before.
   - JS absent   -> the browser jumps to the same anchor. Still lands on the
                    grid, just without the animation.
   - Cmd/ctrl/middle-click -> opens in a new tab, as any link should.
   - Right-click "Copy link" works. Crawlers see a real destination.

   One delegated listener handles every CTA on the page, so sections do not
   each need their own inline handler.
   ============================================================================ */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[data-os-scroll]') : null;
    if (!link) return;

    /* Let the browser handle anything that is not a plain left-click, so
       open-in-new-tab keeps working. */
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var selector = link.getAttribute('data-os-scroll');
    if (!selector) return;

    var target;
    try {
      target = document.querySelector(selector);
    } catch (err) {
      /* A malformed selector must not break the click. Fall through to the
         href, which is what the old hero CTA failed to do - it rendered
         querySelector('.') and threw on every click. */
      return;
    }

    /* Target not on this page? Do nothing and let the href navigate. */
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });

    /* Move focus so keyboard and screen-reader users follow the visual jump. */
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();